module.exports = "<h2>Compoenent User list On UserModule</h2>"


//////////////////
// WEBPACK FOOTER
// /home/xpro/Documentos/ances/myjangular/src/app/users/user-list/user-list.component.html
// module id = ../../../../../src/app/users/user-list/user-list.component.html
// module chunks = main